module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/ht25.846d45d5.png";